import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import NoteListItem from '../../../components/NotesPage/NoteListItem';

const mapStateToProps = (state: StoreState) => {
	const {
		notes: {
			editor: { isOpened },
			loadingStatus,
		},
	} = state;

	return {
		isOpened,
		loadingStatus,
	};
};

export default connect(mapStateToProps)(NoteListItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/NotesPage/NoteListItem/index.tsx